import { Box, BoxProps, styled, Typography } from '@mui/material';

type HeaderComponentProps = {
  titleText: string;
  downloadUrl: string;
};

export const HeaderComponent = ({ titleText }: HeaderComponentProps) => {
  return (
    <TitleBox>
      <Typography variant="h1">{titleText}</Typography>
    </TitleBox>
  );
};
const TitleBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: theme.spacing(8),
}));
